export default __webpack_public_path__ + "static/media/gallery (19).76778211.png";